import React from "react";
import EvalResponses from "./EvalResponses";

const RATING_OPTIONS = [
  'Significantly',
  'Somewhat',
  'Not at all',
  'Not a goal'
];

export default function EvalEventEducatorResponses(props) {
  return (
    <EvalResponses
      {...props}
      table="evaluationEventEducator"
      ratingOptions={RATING_OPTIONS}
    />
  );
}
